import * as React from "react";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";
import { useGetBusinessReportsQuery } from "@/modules/snapshots/businessReports.api";
import { SnapshotCollectionsTemplatesRow } from "./templatesRow";
import { useSearchParams } from "react-router";
import { useGetSnapshotCollectionsQuery } from "@/modules/snapshots/snapshotCollection.api";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";

const emptyList: BusinessReport[] = [];
const emptyCollectionList: SnapshotCollection[] = [];

interface Props {
  selectedBusinessReport: BusinessReport | null;
  setSelectedBusinessReport: (businessReport: BusinessReport) => void;
}

const QUERY_KEY = "businessReportId";
export const SnapshotCollectionsTemplates: React.FC<Props> = ({
  selectedBusinessReport,
  setSelectedBusinessReport,
}) => {
  const { data: templates = emptyList } = useGetBusinessReportsQuery();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: collections = emptyCollectionList } = useGetSnapshotCollectionsQuery();

  const businessReportId = searchParams.get(QUERY_KEY);

  React.useEffect(() => {
    if (templates.length) {
      setSelectedBusinessReport(templates.find(row => row.id === businessReportId) || templates[0]);
    }
  }, [templates, setSelectedBusinessReport, businessReportId]);

  const handleSelectedBusinessReport = (businessReport: BusinessReport) => {
    setSelectedBusinessReport(businessReport);
    setSearchParams(prev => {
      prev.delete("snapshotCollectionId");
      prev.set(QUERY_KEY, businessReport.id);
      return prev;
    });
  };

  return (
    <>
      <h3 className="mb-5 text-2xl font-semibold">Templates</h3>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {templates.map(template => (
          <SnapshotCollectionsTemplatesRow
            key={template.id}
            businessReport={template}
            snapshotCollections={collections.filter(collection => collection.business_report_id === template.id)}
            setSelectedBusinessReport={handleSelectedBusinessReport}
            isSelected={selectedBusinessReport?.id === template.id}
          />
        ))}
      </div>
    </>
  );
};
